import { get } from 'lodash';
export function getBorder(theme, border) {
  return get(theme, "borders.".concat(border), border);
}
export function getColor(theme, color) {
  return get(theme, "colors.".concat(color), color);
}
export function getPreset(theme, presetType, preset) {
  return get(theme, "".concat(presetType, ".presets.").concat(preset), {});
}
export function getRadius(theme, radius) {
  return get(theme, "radii.".concat(radius), radius);
}
export function getShadow(theme, value) {
  return get(theme, "shadows.".concat(value), value);
}
export function getSpacing(theme, value) {
  return get(theme, "spacing.".concat(value), value);
}
export function getBreakpoint(theme, breakpoint) {
  return get(theme, "breakpoints.".concat(breakpoint), breakpoint);
}
export function getShimmerOptions(theme, name) {
  return get(theme, "shimmer.".concat(name), {});
}